import Dashboard from "@/views/gekko/Dashboard";
import Costs from "@/views/gekko/Costs";
import Hours from "@/views/gekko/Hours";
import Bank from "@/views/gekko/Bank";
import BankConnection from "@/views/gekko/BankConnection";
import Invoices from "@/views/gekko/Invoices";
import Quotations from "@/views/gekko/Quotations";
import EditCost from "@/components/costs/EditCost";
import Contacts from "@/views/gekko/Contacts"
import Trips from "@/views/gekko/Trips";
import AddEditContact from "@/components/contacts/AddEditContact";
import AddEditProject from "@/components/contacts/AddEditProject";
import AddEditTrip from "@/components/trips/AddEditTrip";
import BalanceSheet from "@/views/gekko/BalanceSheet";
import CostTypesSettings from "@/views/settings/CostTypesSettings";
import AddEditInvestmentItem from "@/components/balance_sheet/AddEditItem";
import FinancialReporting from "@/views/gekko/FinancialReporting";
import Documents from "@/views/gekko/Documents";
import AddEditDocument from "@/components/documents/AddEditDocument";
import ShareDocument from "@/components/documents/ShareDocument";
import Reports from "@/views/gekko/Reports";
import HoursReport from "@/views/gekko/HoursReport";
import TaxreportList from "@/views/gekko/TaxreportList";
import Taxreport from "@/views/gekko/Taxreport";
import ForeignVATList from "@/views/gekko/ForeignVATList";
import ForeignVAT from "@/views/gekko/ForeignVAT";
import Products from "@/views/gekko/Products";
import ProductList from "@/views/settings/ProductList";
import ForeignTaxReport from "@/views/gekko/ForeignTaxReport";
import CustomerInsight from "@/views/gekko/CustomerInsight";
import SupplierInsight from "@/views/gekko/SupplierInsight";
import invoicesRoutes from "./invoices/"
import quotationsRoutes from "./quotations"

const routes = [
    { path: '/:language/dashboard', name: 'Dashboard', component: Dashboard, meta: { title: 'Dashboard' } },
    { path: '/:language/costs/', name: 'Costs', component: Costs, meta: { title: 'Costs' }, pathToRegexpOptions:{strict:true}, children: [
        { path: 'edit/:costId', component: EditCost, name: 'EditCost', meta: { title: 'Edit costs' }  },
        { path: 'add/', component: EditCost, name: 'AddCost', meta: { title: 'Add cost' }  },
    ] },
    { path: '/:language/hours/', name: 'Hours', component: Hours, meta: { title: 'Hours' }, pathToRegexpOptions:{ strict:true } },
    { path: '/:language/bank/', name: 'Bank', component: Bank, meta: { title: 'Bank' }, pathToRegexpOptions:{ strict:true } },
    { path: '/:language/add-bank-connection/', name: 'BankConnection', component: BankConnection, meta: { title: 'Add Bank Connection' }, pathToRegexpOptions:{ strict:true } },

    {
      path: '/:language/invoices/',
      name: 'Invoices',
      meta: { title: 'Invoices' },
      component: Invoices,
      pathToRegexpOptions: { strict: true },
      children: [
        ...invoicesRoutes
      ] 
    },
    {
      path: '/:language/quotations/',
      name: 'Quotations',
      meta: {title: 'Quotations'},
      component: Quotations,
      pathToRegexpOptions: {strict: true},
      children: [
        ...quotationsRoutes
      ]
    },

    { path: '/:language/addressbook/', name: 'Contacts', component: Contacts, meta: { title: 'Contacts' }, pathToRegexpOptions: { strict: true }, children: [
      { path: 'contact/edit/:contactId', component: AddEditContact, name: 'EditContact', meta: { title: 'Edit contact' } },
      { path: 'contact/add/', component: AddEditContact, name: 'AddContact', meta: { title: 'Add contact' } },
      { path: 'project/edit/:contactId/:projectId', component: AddEditProject, name: 'EditProject', meta: { title: 'Edit project' } },
      { path: 'project/add/:contactId', component: AddEditProject, name: 'AddProject', meta: { title: 'Add project' } }
    ] },
    { path: '/:language/trips/', name: 'Trips', component: Trips, meta: { title: 'Trips' }, pathToRegexpOptions: {strict: true}, children: [
      { path: 'edit/:tripId', component: AddEditTrip, name: 'EditTrip', meta: { title: 'Edit trip' }},
      { path: 'add/', component: AddEditTrip, name: 'AddTrip', meta: { title: 'Add trip' }}
    ] },
    { path: '/:language/investments/', name: 'BalanceSheet', component: BalanceSheet, meta: { title: 'Balance Sheet Investments' }, pathToRegexpOptions:{ strict:true }, children: [
      { path: 'costtypes/', component: CostTypesSettings, name: 'CostTypes', meta: { title: 'Cost types' } },
      { path: 'editcost/:costId', component: EditCost, name: 'BalanceSheetEditCost', meta: { title: 'Edit costs' } },
      { path: 'additem/', component: AddEditInvestmentItem, name: 'AddInvestmentItem', meta: { title: 'Add item' } },
      { path: 'edititem/:investmentId', component: AddEditInvestmentItem, name: 'EditInvestmentItem', meta: { title: 'Edit item' } }
    ] },
    { path: '/:language/financial-statements/', name: 'FinancialStatements', component: FinancialReporting, meta: { title: 'Financial Statements' }, pathToRegexpOptions:{ strict:true }, children: [] },
    { path: '/:language/documents/', name: 'Documents', component: Documents, meta: {title: 'Documents'}, pathToRegexpOptions: {strict: true}, children: [
      {path: 'edit/:documentId', component: AddEditDocument, name: 'EditDocument', meta: { title: 'Edit documents' }},
      {path: 'add/', component: AddEditDocument, name: 'AddDocument', meta: { title: 'Add document'}},
      {path: 'share/', component: ShareDocument, name: 'ShareDocuments', meta: { title: 'Share Documents'},
        children: [
          {path: ':documentId', component: ShareDocument, name: 'ShareDocument', meta: { title: 'Share document' }}
        ]
      }
    ]},
    { path: '/:language/reports/', name: 'Reports', component: Reports, meta: { title: 'Reports'}, pathToRegexpOptions: {strict: true}, children: [] },
    { path: '/:language/reports/hours/', component: HoursReport, name: 'HoursReport', meta: { title: 'Hours Report' }, pathToRegexpOptions: {strict: true}, children: []  },
    { path: "/:language/reports/vat/", component: TaxreportList, name: "TaxreportList", meta: { title: 'Reports' }, pathToRegexpOptions: {strict: true}, children: [
        { path: "create/", component: Taxreport, name: "CreateTaxreport", meta: { title: 'Create report' } },
        { path: ":id/", component: Taxreport, name: "ViewTaxreport", meta: { title: 'View report' } },
    ]},
    { path: "/:language/reports/foreign-vat/", component: ForeignVATList, name: "ForeignVATList", meta: { title: 'Foreign VAT Report' } },
    { path: "/:language/reports/foreign-vat/:id", component: ForeignVAT, name: "ForeignVAT", meta: { title: 'Foreign VAT Report' } },
    { path: "/:language/reports/foreign-vat-report/", component: ForeignVAT, name: "ForeignVATSample", meta: { title: 'Foreign VAT Report' } },
    { path: "/:language/reports/products/", component: Products, name: "Products", meta: { title: "Products" }, pathToRegexpOptions:{ strict:true }, children: [
      {path: "list/", component: ProductList, name: "ProductListModal", meta: {title: "Product List"}}
    ] },
    { path: "/:language/reports/foreign-vat/", component: ForeignTaxReport, name: "ForeignTaxReport", meta: { title: "Foreign Tax Report" }, pathToRegexpOptions:{ strict:true }, children: [] },
    { path: "/:language/reports/customer-insight/", component: CustomerInsight, name: "CustomerInsight", meta: { title: "Customer Insight" }, pathToRegexpOptions:{ strict:true }, children: [] },
    { path: "/:language/reports/supplier-insight/", component: SupplierInsight, name: "SupplierInsight", meta: { title: "Supplier Insight" }, pathToRegexpOptions:{ strict:true }, children: [] }
  ];

export default routes;
